"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var base_1 = tslib_1.__importDefault(require("../base"));
var ProjectFeeAccumulationGroupResource = /** @class */ (function (_super) {
    tslib_1.__extends(ProjectFeeAccumulationGroupResource, _super);
    function ProjectFeeAccumulationGroupResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ProjectFeeAccumulationGroupResource.endpoint = '/projectfeeaccumulationgroups';
    ProjectFeeAccumulationGroupResource.MODEL_NAME = 'projectfeeaccumulationgroup';
    return ProjectFeeAccumulationGroupResource;
}(base_1.default));
exports.default = ProjectFeeAccumulationGroupResource;
//# sourceMappingURL=projectfeeaccumulationgroup.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@sigmacloud/sigma-client/dist/resources/system/projectfeeaccumulationgroup.js
// module id = 2P2F
// module chunks = 0